export default __webpack_public_path__ + "static/media/stellar-xlm-logo.b2cfc512.svg";